<template>
    <div class="page__main is-offset container">
    </div>
</template>
<script>
    export default {
        beforeCreate: function () {
            $(document).ready(function () {
                $('#footerContactInfo').click();
            })
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/Components/HelpDocumentsInfo.vue